import { PermissionsEnum } from "../enums/permissions.enum";
import { FBase } from "./FBase";
import { isObject } from "@pineapplelab/util";
import { SocialMedia } from "./util/socialMedia";
export class Project extends FBase {

	name: string = null;
	permissions: PermissionsEnum[] = [];
	logo: string = null;
	headerLogo: string = null;
	cssFileUrl: string = null;
	languages: string[] = [];
	uniqueClientUsername: string = null;
	showLogoOnLogin: boolean = false;
	footerLogo: string = null;
	socialMedia: SocialMedia[] = [];
	accentColor: string = null;
	accentColorDark: string = null;
	accentColorLight: string = null;
	backgroundColor: string = null;
	backgroundColorDark: string = null;
	backgroundColorLight: string = null;
	headerBackgroundColor: string = null;
	headerLandingPage: string = null;
	lightColor: string = null;
	menuItemsColor: string = null;
	primaryColor: string = null;
	primaryColorDark: string = null;
	primaryColorLight: string = null;
	warnColor: string = null;
	warnColorDark: string = null;
	warnColorLight: string = null;
	translationVersion: number = null;
	messageHeader: string = null;
	maintenanceMode: {
		active: boolean,
		message: string
	} = { active: false, message: null }
	activityTrackingFeatureFlag: string[] = [];
	/** Live presence (online users dashboard). Same convention as the flag above: empty = everyone, else only these user ids. */
	presenceFeatureFlag: string[] = [];
	tenantsWithSignature: string[] = [];

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}

}

export namespace Project {

	export const PATH = 'projects';

}
